/**
 * Where the reader left off, remembered per thread in localStorage: the id of
 * the newest message they had on screen. Read once per mount to place the
 * "New" line, written whenever they reach the bottom of a visible thread.
 */

/** One key per worker thread; Smithers' thread is keyed by business instead. */
export function seenKeyFor(workerId: string | null, businessId: string): string {
  return `caw:chat-seen:${workerId ?? `manager:${businessId}`}`;
}

export function readSeen(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeSeen(key: string, id: string) {
  try {
    localStorage.setItem(key, id);
  } catch {
    // Storage may be unavailable; the divider is then simply not remembered.
  }
}
